import {createContext, useContext} from "react";

import {IUserProfile} from "../../types/IUserProfile";

export interface ICountryCode {
    value: number;
    label: string;
}

export interface IUserUpdatePhoneNumberModalContextValue {
    getUserProfile: () => Promise<IUserProfile | null>;
    updateUserProfile: (data: {name: string; phone: string}) => Promise<{error?: {data?: Record<string, string[]>}}>;
    getCountryCodes: () => ICountryCode[];
    onClose: () => void;
    onError: (error: {message: string}) => void;
    getValidationMessage: (key: string) => string;
    defaultCountryCode: string | number;
}

export const UserUpdatePhoneNumberModalContext = createContext<IUserUpdatePhoneNumberModalContextValue | null>(null);

export const useUserUpdatePhoneNumberModalContext = () => {
    const context = useContext(UserUpdatePhoneNumberModalContext);
    if (!context) {
        throw new Error("useUserUpdatePhoneNumberModalContext must be used within UserUpdatePhoneNumberModalProvider");
    }
    return context;
};
